export default __webpack_public_path__ + "static/media/letters.03feae1a.svg";